import { render, staticRenderFns } from "./AdItemTable.vue?vue&type=template&id=52f877dc&"
import script from "./AdItemTable.vue?vue&type=script&lang=ts&"
export * from "./AdItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports